module.exports = __webpack_public_path__ + "static/logo-new-20971b818465ffb57535a11e26de621c.png";